module.exports = __webpack_public_path__ + "img/Baisc_perc_numbers.225347fe.png";